import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { getStyleVar } from '../utils';

import StudentHelperService from '../services/StudentHelperService';

const StudentProgressSummaryChartWidget = observer((props = {}) => {
  const {
    onlyRenderInnerWidgetContent,
    pieChartFontColor = getStyleVar('--student-progress-summary-default-font-color'),
    t
  } = props;

  const { studentProgressManager } = useContext(MobXProviderContext);
  const { classroomProgressData } = studentProgressManager;

  // Set default values when props are not provided
  const hasAssignments = props.hasAssignments !== undefined ? props.hasAssignments : (
    Object.keys(classroomProgressData.grades).length > 0
  );
  const summary = props.summary !== undefined ? props.summary : classroomProgressData.summary;
  // TODO unused
  // const loading = props.loading !== undefined ? props.loading : (
  //   appManager.initializingApp || !userManager.loaded || !classroomManager.loaded
  // );

  const Legend = props.Legend || (({ data } = {}) => {
    const result = StudentHelperService.getProgressSummaryLegend({ data });
    return result;
  });

  const D3PieChart = SatCoreComponent('D3PieChart');

  const summaryPieData = [];
  let summaryHighCount, summaryMediumCount, summaryLowCount;
  if (summary) {
    summaryHighCount = summary.high || summary.advanced;
    if (summaryHighCount) {
      summaryPieData.push({
        color: getStyleVar('--student-progress-summary-legend-high-color'),
        label: summaryHighCount.toString?.(),
        text: t('highText'),
        value: summaryHighCount
      });
    }

    summaryMediumCount = summary.medium || summary.competent;
    if (summaryMediumCount) {
      summaryPieData.push({
        color: getStyleVar('--student-progress-summary-legend-medium-color'),
        label: summaryMediumCount.toString?.(),
        text: t('mediumText'),
        value: summaryMediumCount
      });
    }

    summaryLowCount = summary.low || summary.beginner;
    if (summaryLowCount) {
      summaryPieData.push({
        color: getStyleVar('--student-progress-summary-legend-low-color'),
        label: summaryLowCount.toString?.(),
        text: t('lowText'),
        value: summaryLowCount
      });
    }

    summaryPieData.forEach((x) => {
      x.tooltip = `
        <div>${x.text}</div>
        <div>${x.label}</div>
      `;
    });
  }

  const ariaLabelStudentSummaryWidget = (hasAssignments && summary) ? t('ariaLabelStudentSummaryWidget', {
    summaryHighCount: summaryHighCount || 0,
    summaryHighCountAssignments: summaryHighCount !== 1 ? t('assignments') : t('assignment'),
    summaryLowCount: summaryLowCount || 0,
    summaryLowCountAssignments: summaryLowCount !== 1 ? t('assignments') : t('assignment'),
    summaryMediumCount: summaryMediumCount || 0,
    summaryMediumCountAssignments: summaryMediumCount !== 1 ? t('assignments') : t('assignment')
  }) : t('ariaLabelStudentSummaryWidgetNoScoresYet');

  const innerWidgetContent = (
    <>
      {hasAssignments && summary ? (
        <div aria-hidden={true} className='summary'>
          <D3PieChart
            data={summaryPieData}
            fontColor={pieChartFontColor}
            fontSize={10}
            height={116}
            labelPlacement={0.3}
            width={116} />
          {!!Legend && (
            <Legend data={summary} t={t} />
          )}
        </div>
      ) : (
        <div aria-hidden={true} className='no-scores'>
          <p>{t('noScoresYet')}</p>
        </div>
      )}
    </>
  );
  return !onlyRenderInnerWidgetContent ? (
    <div aria-label={ariaLabelStudentSummaryWidget}
      className='StudentProgressSummaryChartWidget StudentProgressWidget widget summary-widget student-summary-widget' tabIndex='0'>
      <h2 aria-hidden={true} className='w-title'>
        {t('SummaryLabel', 'Missing summary label translation')}
      </h2>
      {innerWidgetContent}
    </div>
  ) : innerWidgetContent;
});

export default StudentProgressSummaryChartWidget;

SatCoreRegister('StudentProgressSummaryChartWidget', StudentProgressSummaryChartWidget);
